var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.188 1.375H4.813A1.376 1.376 0 0 0 3.438 2.75v17.188a.687.687 0 0 0 .687.687h.688a.685.685 0 0 0 .55-.275l1.512-2.016 1.512 2.016a.71.71 0 0 0 1.1 0L11 18.334l1.512 2.016a.711.711 0 0 0 1.1 0l1.513-2.016 1.512 2.016a.687.687 0 0 0 .55.275h.688a.687.687 0 0 0 .688-.688V2.75a1.376 1.376 0 0 0-1.375-1.375zm0 17.416-1.513-2.016a.711.711 0 0 0-1.1 0l-1.512 2.016-1.513-2.016a.711.711 0 0 0-1.1 0l-1.512 2.016-1.513-2.016a.71.71 0 0 0-1.1 0l-1.513 2.016V2.75h12.375v16.041z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.615 5.434c1.106 0 1.912.226 2.42.68.508.452.762 1.087.762 1.904 0 .37-.059.724-.176 1.06a2.25 2.25 0 0 1-.562.885c-.262.254-.608.455-1.037.603-.426.149-.952.223-1.577.223h-.914V14H8.125V5.434h2.49zM10.521 6.6h-.99v3.017h.768c.441 0 .816-.05 1.125-.152.308-.106.543-.272.703-.498.16-.227.24-.526.24-.897 0-.496-.15-.865-.451-1.107-.297-.242-.762-.363-1.395-.363z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseInvoiceIcon);
export default __webpack_public_path__ + "static/media/purchaseInvoiceIcon.e902d825d66b9af58e5cfc73aa375bda.svg";
export { ForwardRef as ReactComponent };